<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <select-input
                    :formData="data"
                    :label="$t('forms.user.change_company_user_role.fields.company_role.label')"
                    :placeholder="$t('forms.user.change_company_user_role.fields.company_role.placeholder')"
                    :isRequired="true"
                    :options="companyRoles"
                    valuePath="companyRoleEnum"
                    @change="change"
                ></select-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :label="$t('forms.user.change_company_user_role.buttons.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'
    import CompanyRoles from 'enums/company_roles.enum'

    export default {
        mixins: [FormMixin],
        props: {
            companyId: { type: Number, required: true },
            userId: { type: Number, required: true },
            companyRole: { type: String, required: true },
            showOnPublicProfile: { type: Boolean, default: false },
            showPublicProfile: { type: Boolean, default: false },
        },

        computed: {
            companyRoles() {
                return [
                    {
                        label: this.$t('forms.user.change_company_user_role.select.admin'),
                        value: CompanyRoles.COMPANY_ADMIN.VALUE,
                    },
                    { label: this.$t('forms.user.change_company_user_role.select.user'), value: CompanyRoles.COMPANY_USER.VALUE },
                ]
            },
        },
        methods: {
            submit() {
                this.submitForm(
                    UsersAPI.updateCompanyRole({
                        userId: this.userId,
                        companyRoleEnum: this.data.companyRoleEnum,
                        companyId: this.companyId,
                        showOnPublicProfile: this.showOnPublicProfile,
                        showPublicProfile: this.showPublicProfile,
                    }).then(() =>
                        this.emitEvent({ name: 'company-role-changed', payload: { companyRole: this.data.companyRoleEnum } }),
                    ),
                ).catch((error) => {
                    this.$toast.error(
                        this.$t(
                            `forms.user.change_company_user_role.errors.${error.error.message.replace('.', '_').toLowerCase()}`,
                        ),
                    )
                })
            },
            prefillFormData() {
                const prefill = {
                    companyRoleEnum: this.companyRole,
                }
                this.prefillData(prefill)
            },
        },
        mounted() {
            this.prefillFormData()
        },
    }
</script>
